/**
 * Created by TzuHsing on 2020-02-15
 */
import {
  GETADV_UPLOADEDLIST,
  GETADV_UNPUBLISHEDLIST,
  GETADV_UNCHECKLIST,
  GETADV_DELETEDLIST,
  GETADV_UNIONLIST,
  MISSPARAM,
} from './constants'
import { API_DOMAIN } from '../../config'
import { fetchData, postData } from '../../util'
import { message } from 'antd'

export const getAdvList = (payload, str) => {
  return {
    type: str,
    payload,
  }
}

export const fetchAdvList = (clubId, num, callback) => {
  let str
  if (num === 3) {
    str = GETADV_UPLOADEDLIST
  } else if (num === 2) {
    str = GETADV_UNPUBLISHEDLIST
  } else if (num === 1) {
    str = GETADV_UNCHECKLIST
  } else if (num === 4) {
    str = GETADV_DELETEDLIST
  }
  return async (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/AfterPaidAdApi/afterPaidAdList?club_id=${clubId}&state=${num}`
    const res = await fetchData(endpoint)
    if (res.status === MISSPARAM) {
      message.error('参数错误')
    } else {
      dispatch(getAdvList(res.data, str))
      callback && callback()
    }
  }
}
export const fetchUnionAdvList = (callback) => {
  return async (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/AfterPaidAdApi/afterPaidAdList?club_id=0&state=3`
    const res = await fetchData(endpoint)
    if (res.status === MISSPARAM) {
      message.error('参数错误')
    } else {
      dispatch(getAdvList(res.data, GETADV_UNIONLIST))
      callback && callback()
    }
  }
}

export const changeAdvInfo = (body, callback) => {
  return async (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/AfterPaidAdApi/editAd`
    const res = await postData(endpoint, 'POST', JSON.stringify(body))
    callback && callback(res)
  }
}

export const addAdv = (body, callback) => {
  return async (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/AfterPaidAdApi/addAd`
    const res = await postData(endpoint, 'POST', JSON.stringify(body))
    callback && callback(res)
  }
}

export const changeAdvState = (body, callback) => {
  return async (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/Home/AfterPaidAdApi/editAdState`
    const res = await postData(endpoint, 'POST', JSON.stringify(body))
    callback && callback(res)
  }
}



// WEBPACK FOOTER //
// ./src/containers/CheckOutAdvManage/action.js